import { render } from "./fairtech.vue?vue&type=template&id=b7e71fc6"
import script from "./fairtech.vue?vue&type=script&lang=js"
export * from "./fairtech.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__